// src/components/ui/TextAreaField.jsx
const TextAreaField = ({ label, className = "", ...props }) => (
  <div>
    {label && (
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label}
      </label>
    )}
    <textarea
      {...props}
      rows={props.rows || 3}
      className={`w-full border border-gray-200 rounded-lg px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition placeholder-gray-400 resize-none ${className}`}
    />
  </div>
);

export default TextAreaField;
